import { isContentRestrictedForUser } from 'common/helpers/permission.helper';
import { useAppSelector } from 'app/store/store.hooks';

// True when the current authUser falls under READ_ONLY_CONTENT_RESTRICTIONS
// (see permission.helper.ts) — mutation UI should hide/disable itself.
export function useIsContentRestricted(): boolean {
  const authUser = useAppSelector((state) => state.auth.authUser);

  return isContentRestrictedForUser(authUser);
}
